import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class RoomTypeDto extends BaseDto {
    id: number;
    merchantGroup: MerchantGroupDto;
    name: string;
    code: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

}